module.exports = __webpack_public_path__ + "img/return.78937e9e.png";